import Constant from '../common/Constant';

import { store } from './store';

export function getProjectWithId(id) {
  const project = store.getState().projects.find(p => p.id === id);

  if (project) {
    return project;
  }

  return {
    name: '',
    color: '',
    currencyCode: Constant.DEFAULT_CURRENCY_CODE,
    hourlyRate: 0.0,
  };
}

export function isArchived(project) {
  return (
    project.archivedAt !== undefined &&
    project.archivedAt !== null &&
    project.archivedAt.length > 0
  );
}



// WEBPACK FOOTER //
// ./src/helpers/project.js